/**
 * 참고 : https://github.kakaocorp.com/kakaopage/api/blob/deploy/alpha/api/src/main/java/com/kakaopage/api/service/appconfig/AppConfigKey.java
 */
export enum AppConfigKeyVo {
  CertificationMethod = 'certification_method', // init
  GiftLastAddedDate = 'gift_last_added_date', // badge
  NoticeLastAddedDate = 'notice_last_added_date', // badge
  MyNewsLastAddedDate = 'my_news_last_added_date', // badge
  HelixGiftLastAddedData = 'helix_gift_last_added_date', // badge
  MarketingAgreement = 'marketing_agreement', // setting
  NightMarketingAgreement = 'night_marketing_agreement', // setting
  /**
   * 마케팅 활용을 위한 개인정보 제3자 제공 동의
   * 이 값은 티아라의 third_ad_agree 에 사용됩니다. (third_provide_agree 는 네이밍을 잘못 지은거임)
   */
  PagePrivateThirdOffer = 'third_provide_agreement', // setting
  TastesHome = 'tastes_home',
  TastesGenre = 'tastes_genre',
  TastesServiceLang = 'tastes_service_lang',
  GeoIp = 'geo_ip',
}
